export default "__VITE_ASSET__UrJDthAL__"